

























































































































































import Vue from 'vue'

import { json2csv } from '@/utils/csv'
import CsvImport from '@/components/csv-import/index.vue'

import {
  FindField,
  CreateField,
  PatchField,
  GetField,
  DeleteField,
  ImportFields,
} from '@/api/collector'
import { Field } from '../../../types/collector'

export default Vue.extend({
  name: 'TableCollector',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  components: {
    CsvImport,
  },
  data() {
    return {
      items: [] as Field[],
      newItem: {} as Field,
      selectedItem: {} as Field,
      selectedId: -1,
      collectorId: -1,
    }
  },
  methods: {
    // ----------------------------------------------------------------------------------------
    // Data initialization
    // ----------------------------------------------------------------------------------------
    initNewItem() {
      this.newItem.id = 0
      this.newItem.collectorId = -1
      this.newItem.name = ''
      this.newItem.alias = ''
      this.newItem.description = ''
    },
    // ----------------------------------------------------------------------------------------
    // Database operation
    // ----------------------------------------------------------------------------------------
    async create(c: Field) {
      c.collectorId = this.collectorId
      await CreateField(c)
    },

    async import(fields: Field[]) {
      if (this.collectorId == -1) {
        return
      }
      await ImportFields(this.collectorId, fields)
    },

    async find(q?: Field) {
      q = q || ({} as Field)
      q.collectorId = this.collectorId
      this.items = await FindField(q)
    },

    async get(id: number) {
      return await GetField(id)
    },

    async patch(id: number, f: Field) {
      return await PatchField(id, f)
    },

    async delete(id: number) {
      return await DeleteField(id)
    },

    // ----------------------------------------------------------------------------------------
    // Toolbars
    // ----------------------------------------------------------------------------------------
    onToolbarRefresh() {
      if (this.collectorId == -1) return

      this.selectedId = -1
      this.find()
    },

    async onToolbarSave() {
      if (this.collectorId == -1) return

      if (this.selectedId == -1) {
        if (this.newItem.name.length < 2) {
          return
        }
        await this.create(this.newItem)
        this.initNewItem()
        await this.find()
      } else {
        await this.patch(this.selectedId, this.selectedItem)
        await this.find()
      }
    },

    async onToolbarDelete() {
      if (this.collectorId == -1) return

      if (this.selectedId == -1) {
        return
      }

      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },

    onToolbarExport2Excel() {
      const filename = `collector_${this.collectorId}_fields.csv`
      const fields = ['id', 'collectorId', 'name', 'alias', 'description']
      json2csv(fields, this.items, filename)
    },

    // eslint-disable-next-line
    onToolbarImportClick(on: any) {
      if (this.collectorId == -1) {
        return
      }
      return on
    },

    async onToolbarImportCSV(data: Field[]) {
      if (data.length < 1) {
        return
      }
      const d = data.map((f) => {
        return {
          ...f,
          id: parseInt(f.id.toString()),
          collectorId: parseInt(f.collectorId.toString()),
        }
      })
      await this.import(d)
      await this.find()
    },

    // ----------------------------------------------------------------------------------------
    // Dialogs
    // ----------------------------------------------------------------------------------------
    async onDialogDeleteOk() {
      await this.delete(this.selectedId)
      this.selectedId = -1
      await this.find()
    },

    // ----------------------------------------------------------------------------------------
    // Keyboard & mouse events
    // ----------------------------------------------------------------------------------------
    onRowClicked(f: Field) {
      this.selectedId = f.id
      this.selectedItem = f
    },

    async onEnterKeyUp() {
      await this.patch(this.selectedId, this.selectedItem)
      await this.find()
    },

    async onNewDataEnterKeyUp() {
      if (this.collectorId == -1) return
      await this.create(this.newItem)
      this.initNewItem()
      await this.find()
    },

    onNewDataClicked() {
      this.selectedId = -1
    },
  },

  watch: {
    value: function(val) {
      this.items = []
      this.collectorId = val
      if (val == -1) return
      this.find()
    },
  },

  created() {
    this.initNewItem()
  },
})
